import script from "./CampaignTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignTabs.vue?vue&type=script&setup=true&lang=js"

import "./CampaignTabs.vue?vue&type=style&index=0&id=4c56f95c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c56f95c"]])

export default __exports__